<div class="form-horizontal">
    <div class="form-group">
      <label class="col-md-2 control-label">Equipo:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Equipo</mat-label>
            <input matInput type="text" placeholder="Equipo" [(ngModel)]="equipo.equipo" [disabled]="disabled">
          </mat-form-field>                
        </div>

        <label class="col-md-2 control-label">Marca:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Marca</mat-label>
            <input matInput type="text" placeholder="marca" [(ngModel)]="equipo.marca" [disabled]="disabled">
          </mat-form-field>                
        </div>
    </div>   
    <div class="form-group">
      <label class="col-md-2 control-label">Modelo:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Modelo</mat-label>
            <input matInput type="text" placeholder="modelo" [(ngModel)]="equipo.modelo" [disabled]="disabled">
          </mat-form-field>
        </div>  

      <label class="col-md-2 control-label">Serie:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Serie</mat-label>
          <input matInput type="text" placeholder="serie" [(ngModel)]="equipo.serie" [disabled]="disabled">
        </mat-form-field>            
      </div>  
    </div>

</div>